import http from '../01_axios'
import type { ApiResponse } from '../01_axios/api/response.api'
import * as urls from './components/urls'

// key mặc định 'all' — BE hỗ trợ trả full list khi parentCodeKey === 'all' (xem CacheSystemKey.cs)
const getSystemKey = (key = 'all'): Promise<ApiResponse<any>> =>
  http.get(`${urls.apiGetSystemKey}?key=${key}`)

const CommonService = {
  getSystemKey,
}

export default CommonService
